import React, {
    useState,
    useContext,
    useEffect,
    useCallback,
    useMemo,
} from 'react'
import { DataContext } from '../../DataContext'
import withConfig from '../../../../wrappers/withConfig'
import NewSearchComponent from './NewSearchComponent'
import ExistingSearchComponent from './ExistingSearchComponent'
import defaultUploadObjects from '../../../../../utils/submissions/defaultUploadObjects'
import ToggleComponent from '../ToggleComponent'

const SaveAndContinueButton = withConfig(
    ({ facilityData, continueDisabled, isNew }) => {
        const { setSubmissionState, isSubmitting, setTableData, formType } =
            useContext(DataContext)
        const [error, setError] = useState(null)

        const emptyUploadState = defaultUploadObjects[formType.APILink]

        const primaryKeyValue = isNew
            ? null
            : (facilityData?.[formType.PrimaryAccessor]?.[
                  formType.PrimaryKeyField
              ] ?? null)

        const mergeData = useCallback(() => {
            setSubmissionState((prevSubmissionState) => ({
                ...prevSubmissionState,
                ...emptyUploadState,
                newRecord: Math.random() * 1000,
                ...facilityData,
                [formType.PrimaryAccessor]: {
                    ...facilityData[formType.PrimaryAccessor],
                    [formType.PrimaryKeyField]: isNew ? null : primaryKeyValue,
                },
            }))
            setTableData({})
        }, [
            facilityData,
            emptyUploadState,
            isNew,
            formType,
            setSubmissionState,
            setTableData,
        ])

        useEffect(() => {
            if (continueDisabled) {
                setError(null)
            }
        }, [continueDisabled])

        return (
            <>
                {error ? (
                    <p className="is-full has-text-centered has-text-danger">
                        {error}
                    </p>
                ) : null}
                <div className="buttonWrapper">
                    <button
                        type="button"
                        onClick={() => mergeData()}
                        disabled={continueDisabled}
                        className={`button is-medium is-link ${
                            isSubmitting ? 'is-loading' : ''
                        }`}
                    >
                        {`Continue`}
                    </button>
                </div>
            </>
        )
    }
)

const SearchForm = () => {
    const [isNew, setIsNew] = useState(true)
    const { activePanel, setPrimaryKey, uploadConfig, formType } =
        useContext(DataContext)
    const [facilityData, setFacilityData] = useState(null)
    const [facilityChanged, setFacilityChanged] = useState(true)
    const [isFacilitySelected, setIsFacilitySelected] = useState(false)

    useEffect(() => {
        setFacilityData(null)
    }, [isFacilitySelected])

    const continueDisabled = useMemo(() => {
        if (
            !facilityChanged &&
            facilityData &&
            facilityData.facility &&
            facilityData.facility.agencyFacilityCode
            // ((!isNew && facilityData.facility) ||
            //     (isNew && facilityData.isNewToWaterstar))
        ) {
            return false
        }
        return true
    }, [facilityData, facilityChanged])

    return (
        <div
            className={`columns is-multiline ${
                activePanel !== 'Station Search' ? 'is-hidden' : ''
            }`}
        >
            <div className="column is-12">
                <ToggleComponent
                    onDropDownChange={(newItem) => {
                        setFacilityData(null)
                        setPrimaryKey(null)
                        setFacilityChanged(true)
                        if (newItem !== null) {
                            setIsNew(newItem)
                        }
                    }}
                    formType={formType}
                />
            </div>
            <div className="column is-12">
                <ExistingSearchComponent
                    facilityData={facilityData}
                    setFacilityData={setFacilityData}
                    continueDisabled={continueDisabled}
                    facilityChanged={facilityChanged}
                    setFacilityChanged={setFacilityChanged}
                    uploadConfig={uploadConfig}
                    isNew={isNew}
                />
            </div>
            <div className="column is-12">
                <SaveAndContinueButton
                    facilityData={facilityData}
                    continueDisabled={continueDisabled}
                    isNew={isNew}
                />
            </div>
        </div>
    )
}

export default SearchForm
